import { FormControlLabel, Stack, Switch } from '@mui/material';
import { t } from 'i18next';

type Props = {
  value: boolean;
  disabled: boolean;
  tabIndex: 0 | -1;
  onToggle: () => Promise<void>;
};

export const ExceptionStatusToggle = ({ tabIndex, value, disabled, onToggle }: Props) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <FormControlLabel
        disableTypography
        disabled={disabled}
        control={<Switch tabIndex={tabIndex} checked={value} onChange={onToggle} />}
        label={value ? t('enabled') : t('disabled')}
      />
    </Stack>
  );
};
